module.exports = __webpack_public_path__ + "img/whl (4).e654f93f.png";